import axios from 'axios';

export const GLOBAL_TEMPLATE_URL = '/app/marketingsite/global/template';
export const GLOBAL_TEMPLATE_GROUP_URL = '/app/marketingsite/global/templateGroup';
export const TEMPLATE_URL = '/app/marketingsite/template';
export const TEMPLATE_GROUP_URL = '/app/marketingsite/templateGroup';
export const MARKETING_FORM_URL = '/app/marketingform';
export const TAG_OPTIONS_URL = '/app/tagAppliedGoal/tags/list';


export const getTemplateGroup = async (siteId) => {
    return axios.get(`${TEMPLATE_GROUP_URL}/${siteId}`);
};

export const getTemplate = async (templateId) => {
    return axios.get(`${TEMPLATE_URL}/${templateId}`);
};

export const createTemplateForTemplateGroup = async (templateGroupId, templatePayload) => {
    return axios.post(`${TEMPLATE_GROUP_URL}/${templateGroupId}/template`, templatePayload);
};

export const createTemplateGroup = async (templateGroupPayload, updateThumbnail, retry = true) => {
    try {
        const res = await axios.post(TEMPLATE_GROUP_URL, templateGroupPayload);

        if (updateThumbnail) {
            await patchTemplateGroup(res.data.templateGroupDto.id, {
                updateThumbnail: true,
                builderJson: templateGroupPayload.builderJson,
            });
        }

        return res.data.templateGroupDto;
    } catch (err) {
        if (retry) {
            const alias = `${templateGroupPayload.alias}-${Date.now()}`;

            return createTemplateGroup({ ...templateGroupPayload, alias }, updateThumbnail, false);
        }
        throw err;
    }
};

export const deleteTemplateGroup = async (templateGroupId) => {
    return axios.delete(`${TEMPLATE_GROUP_URL}/${templateGroupId}`);
};

export const deleteTemplate = async (templateId) => {
    return axios.delete(`${TEMPLATE_URL}/${templateId}`);
};

export const patchThumbnail = async (templateGroupId, builderJson) => {
    return axios.patch(`${TEMPLATE_GROUP_URL}/${templateGroupId}`, { builderJson, updateThumbnail: true });
};

export const updateTemplateGroup = async (templateGroupId, updatedTemplateGroupPayload, updateThumbnail) => {
    const res = await axios.put(`${TEMPLATE_GROUP_URL}/${templateGroupId}`, updatedTemplateGroupPayload);

    // skipped the updating thumbnail - similar is done in keap-web.
    // Need ticket for template management for fixing the updateThumbnail
    if (updateThumbnail) {
        await patchTemplateGroup(templateGroupId, {
            updateThumbnail: true,
            builderJson: updatedTemplateGroupPayload.builderJson,
        });
    }

    return res;
};

export const getContactTags = async () => {
    try {
        return axios.get(TAG_OPTIONS_URL, {});
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error({ err });

        return [];
    }
};

export const updateTemplate = async (templateGroupId, templateId, updatedTemplatePayload) => {
    return axios.put(`${TEMPLATE_GROUP_URL}/${templateGroupId}/template/${templateId}`, updatedTemplatePayload);
};

export const getGlobalTemplate = async (templateId) => {
    return axios.get(`${GLOBAL_TEMPLATE_URL}/${templateId}`);
};

export const getGlobalTemplateGroup = async (templateGroupId) => {
    return axios.get(`${GLOBAL_TEMPLATE_GROUP_URL}/${templateGroupId}`);
};

export const publishTemplateGroup = async (publishTemplateGroupPayload) => {
    return axios.put(`${TEMPLATE_GROUP_URL}/publish`, publishTemplateGroupPayload);
};

export const patchTemplateGroup = async (templateGroupId, updatedTemplateGroupPayload) => {
    return axios.patch(`${TEMPLATE_GROUP_URL}/${templateGroupId}`, updatedTemplateGroupPayload);
};

export const createCustomField = async (newCustomField) => {
    return axios.post('/app/customFields/createCustomField?recordType=contact', newCustomField);
};

export const getCustomFields = async () => {
    return axios.get('/app/customFields/getCustomFields?recordType=contact');
};

export const deleteCustomDomain = async (customDomainId) => {
    axios.delete(`/app/customDomains/deleteCustomDomain/${customDomainId}`);
};

export const deleteFormsApiCustomDomain = async (domain, updatedById) => {
    try {
        return axios.delete(`/app/customDomains/deleteFormsApiCustomDomain/${domain}?updatedById=${updatedById}`);
    } catch (e) {
        return null;
    }
};

export const getCustomDomainStatus = async (domainName) => {
    try {
        const { data: { setupComplete } } = await axios.get(`/app/customDomains/getCustomDomainStatus/${domainName}`);

        return setupComplete;
    } catch (error) {
        return false;
    }
};

export const getCustomDomainsForTenant = async () => {
    const { data } = await axios.get('/app/customDomains/getCustomDomainsForTenant');

    return data;
};

export const createCustomDomain = async (payload) => {
    return axios.post('/app/customDomains/createCustomDomain', payload);
};

export const createFormsApiCustomDomain = async (payload) => {
    return axios.post('/app/customDomains/createFormsApiCustomDomain', payload);
};

export const createMarketingForm = async (customField) => {
    return axios.post(`${MARKETING_FORM_URL}?includeFieldInputDetails=true`, customField);
};

export const updateMarketingForm = async (formId, formData) => {
    return axios.put(`${MARKETING_FORM_URL}/${formId}`, formData);
};

export const getMarketingForm = async (formId) => {
    return axios.get(`${MARKETING_FORM_URL}/${formId}`);
};

export const getMarketingFormBySlug = async (formSlug) => {
    return axios.get(`${MARKETING_FORM_URL}/slug/${formSlug}`);
};
